/**
 * Environment configuration
 * Handles environment variables in a way that's compatible with both Vite and Jest
 */

// In test environment, use process.env
// In browser environment, use import.meta.env
export const getEnvironmentVariable = (key: string): string => {
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return process.env[key] || '';
  }
  
  // Browser environment with Vite - use import.meta.env directly
  return import.meta.env[key] || '';
};

// Get API base URL from environment, fallback to relative path for production
const envApiUrl = getEnvironmentVariable('VITE_CREATOR_DASHBOARD_API_URL');

// If no environment variable is set, use relative path (same-origin via CloudFront)
// This ensures production uses CloudFront proxy and avoids CORS issues
export const API_BASE_URL = envApiUrl || '/api';